module.exports = __webpack_public_path__ + "static/media/login.a6877d8a.jpg";